import pickBy from 'lodash/pickBy';
import { stringify } from 'querystringify';
import videoMapping from './metadata/videoMapping.json';
function getPlaybackID(url) {
    return url.split('/')[3].split('.')[0];
}
export var getMuxPlaybackID = getPlaybackID;
export function isMuxUrl(str) {
    return !!(str === null || str === void 0 ? void 0 : str.startsWith('https://stream.mux.com'));
}
// https://docs.mux.com/guides/video/get-images-from-a-video#thumbnail-query-string-parameters
export function getMuxThumbnail(muxUrl, param) {
    var format = param.format, width = param.width, height = param.height, _param_fitMode = param.fitMode, fitMode = _param_fitMode === void 0 ? 'smartcrop' : _param_fitMode, time = param.time, getPixelSizeForLayoutSize = param.getPixelSizeForLayoutSize;
    var id = getPlaybackID(muxUrl);
    var paramObj = {
        width: width ? getPixelSizeForLayoutSize(width) : undefined,
        height: height ? getPixelSizeForLayoutSize(height) : undefined,
        fit_mode: fitMode,
        time: time
    };
    var params = stringify(pickBy(paramObj));
    return "https://image.mux.com/".concat(id, "/thumbnail.").concat(format, "?").concat(params);
}
export function getMuxUrlFromGCSUrl(url) {
    var _videoMapping_url;
    var playbackId = (_videoMapping_url = videoMapping[url]) === null || _videoMapping_url === void 0 ? void 0 : _videoMapping_url.playbackId;
    if (!playbackId) {
        throw new Error('Invalid url for videoMapping: ' + url);
    }
    return "https://stream.mux.com/".concat(playbackId, ".m3u8");
}
